import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactUs from './ContactUs';

const ContactUs_en = () => (
  <div className="lang-en">
    <Helmet>
      <title>Contact Us</title>
      <meta
        name="description"
        content="Contact Tang Wu Biotech for premium catering ingredient sourcing, partnership inquiries, and custom food ingredient solutions."
      />
      <meta name="keywords" content="contact, partnership, food ingredients" />
    </Helmet>
    <ContactUs />
  </div>
);

export default ContactUs_en;
